import React from 'react';
import { Globe } from 'lucide-react';
import { UiLang } from '@/i18n/config';
import { useTranslation } from 'react-i18next';

type Props = { lang: UiLang; onChange: (lang: UiLang) => void; className?: string; tone?: 'light' | 'dark' };

// Liten NO/EN-veksler for offentlige sider (sporing, reiseplan, tilbakemelding, katalog, åpne turer).
export const PublicLanguageToggle: React.FC<Props> = ({ lang, onChange, className = '', tone = 'light' }) => {
  const { t } = useTranslation();
  const base = tone === 'dark'
    ? 'border-white/30 text-white/80 bg-white/10'
    : 'border-slate-200 text-slate-500 bg-white/80';
  const active = tone === 'dark' ? 'bg-white text-slate-900' : 'bg-slate-900 text-white';
  return (
    <div className={`inline-flex items-center rounded-full border overflow-hidden text-[11px] font-semibold ${base} ${className}`}
      data-testid="public-language-toggle" aria-label={t('publicLanguageToggle.sprakLanguage', 'Språk / Language')}>
      <Globe className="w-3 h-3 ml-2 mr-1 opacity-70" aria-hidden="true" />
      {(['no', 'en'] as UiLang[]).map((l) => (
        <button key={l} type="button" onClick={() => onChange(l)} aria-pressed={lang === l}
          className={`px-2 py-1 transition-colors ${lang === l ? active : 'hover:opacity-80'}`}
          data-testid={`public-lang-${l}`}>
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export default PublicLanguageToggle;
